<div
  class="bg-gray-light py-4 px-16 flex gap-16 items-center justify-end"
>
  <ng-content></ng-content>
</div>

